import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import CarrerasView from './CarrerasView';
import * as ROUTES from '../../../router/Routes';

const CarrerasModule = () => {
  return (
    <ContainerTemplate active={ROUTES.carreras} routes={[ROUTES.root]}>
      <CarrerasView />
    </ContainerTemplate>
  );
};

export default CarrerasModule;
